<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
html,
body {

  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  .popperclassForMaindatepageLinContent {
    .el-date-range-picker__header {
      div {
        color: #363636;
      }
    }
  }
}
body{
   min-width: 1384px;
   // background: url("@/assets/images/bg.png") no-repeat;
   background-color: #e9eaef;

}
#app {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  //background: url("./assets/images/bg.png") no-repeat;
  background-size: 100%;

}

.login_image .el-input__inner {
  border: none !important;
  background: transparent;
}
.login_phone .el-input__inner {
  border: none !important;
  background: transparent;
}
.login_captcha .el-input__inner {
  border: none !important;
  background: transparent;
}
// 修改全局滚动条样式
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #d5d5d6;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: #ffffff;
}

</style>
